// extracted by mini-css-extract-plugin
export default {"modal":"EntityFormModal_modal__McuDA","header":"EntityFormModal_header__nnKB9"};